const Callout = ({ children, ...props }) => (
  <div
    className="neeto-molecules-browser-support-callout"
    data-testid="browser-support-callout"
    {...props}
  >
    <p className="neeto-molecules-browser-support-callout__message">
      {children}
    </p>
  </div>
);

export default Callout;
